import { state } from '@angular/animations';
import { Action, createReducer, on } from '@ngrx/store';
import * as actions from '../actions';
import { IProducts } from '../models/products.model';

export const pastProductsForSomeoneElseFeatureKey = 'pastProductsForSomeoneElse';

export interface PastProductsForSomeoneElseState {
  loadPastProductsForSomeoneElseResponse: IProducts[];
  loadPastProductsForSomeoneElseFailure: Error | any;
}

export const initialState: PastProductsForSomeoneElseState = {
  loadPastProductsForSomeoneElseResponse: undefined,
  loadPastProductsForSomeoneElseFailure: undefined
};

export const reducer = createReducer(
  initialState,
  on(actions.loadPastProductsForSomeoneElse, (state, action) => ({
    ...state
  })),
  on(actions.loadPastProductsForSomeoneElseSuccess, (state, action) => ({
    ...state,
    loadPastProductsForSomeoneElseResponse: action.response
  })),
  on(actions.loadPastProductsForSomeoneElseFailure, (state, action) => ({
    ...state,
    loadPastProductsForSomeoneElseFailure: action.error
  }))
);

export const getPastProductsForSomeoneElseResponse = (state: PastProductsForSomeoneElseState) =>
  state.loadPastProductsForSomeoneElseResponse;
